/**
 * SaVicHreflangPair
 * ─────────────────
 * Drop-in component for SA pages that have a Melbourne sibling (or
 * vice-versa). Emits reciprocal en-AU-SA / en-AU-VIC / x-default
 * alternates via useHreflangAlternates (bypasses react-helmet-async's
 * link-rel-alternate dedupe).
 *
 * Renders nothing visible. Cleans up its tags on unmount.
 *
 * Usage:
 *   <SaVicHreflangPair
 *     selfPath="/first-home-buyer-adelaide"
 *     selfState="SA"
 *     siblingPath="/first-home-buyer-melbourne"
 *   />
 */
import useHreflangAlternates from '../hooks/useHreflangAlternates';

const SaVicHreflangPair = ({ selfPath, selfState, siblingPath, pageId }) => {
  const selfHreflang = selfState === 'SA' ? 'en-AU-SA' : 'en-AU-VIC';
  const siblingHreflang = selfState === 'SA' ? 'en-AU-VIC' : 'en-AU-SA';
  const selfHref = `https://buildpilot.com.au${selfPath}`;
  const siblingHref = `https://buildpilot.com.au${siblingPath}`;

  const alternates = [
    { hreflang: selfHreflang, href: selfHref },
    { hreflang: siblingHreflang, href: siblingHref },
    { hreflang: 'x-default', href: selfHref },
  ];

  useHreflangAlternates(alternates, pageId || `savic-${selfState}-${selfPath.replace(/[^a-z0-9]/gi, '-')}`);

  return null;
};

export default SaVicHreflangPair;
